import { AddItemButton } from '@core/components/Buttons';
import { NumberInput } from '@core/components/Inputs';
import { Grid, IconButton, Tooltip } from '@material-ui/core';
import SelectClasseCentroCusto from 'app/components/Select/SelectClasseCentroCusto';
import { useFormikContext } from 'formik';
import React from 'react';
import { MdHighlightOff } from 'react-icons/md';

const RateioContaReceberForm = () => {
  const formik = useFormikContext();

  const handleAdicionarRateio = () => {
    const rateios = formik.values.rateios
      ? [...formik.values.rateios, { id: '', classe: {}, percentual: '' }]
      : [{ id: '', classe: {}, percentual: '' }];
    formik.setFieldValue('rateios', rateios);
  };

  const handleRemoverRateio = (index) => {
    let _rateios = formik.values.rateios.slice();
    _rateios.splice(index, 1);

    if (index === 0 && _rateios.length === 0) {
      formik.setFieldValue('rateios', [{ id: '', classe: {}, percentual: '' }, ..._rateios]);
    } else {
      formik.setFieldValue('rateios', _rateios);
    }
  };

  return (
    <>
      {formik?.values?.rateios?.map((rateio, index) => {
        const _errors = {
          classe:
            (formik?.submitCount > 0 || formik.touched.rateios?.[index]?.classe) &&
            formik.errors.rateios?.[index]?.classe,
          percentual:
            (formik?.submitCount > 0 || formik.touched.rateios?.[index]?.percentual) &&
            formik.errors.rateios?.[index]?.percentual,
        };

        return (
          <Grid container spacing={2} key={index}>
            <Grid item xs={7} sm={7} md={7} xl={7} lg={7}>
              <SelectClasseCentroCusto
                label={'Centro de custo'}
                id={`rateios[${index}].classe`}
                name={`rateios[${index}].classe`}
                value={rateio?.classe || ''}
                onChange={(event) => {
                  formik.setFieldValue(`rateios[${index}].classe`, event.target.value);
                }}
                required
                error={_errors?.classe}
                touched={!!_errors?.classe}
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} xl={4} lg={4}>
              <NumberInput
                required
                label="Percentual (%)"
                id={`rateios[${index}].percentual`}
                decimalScale={2}
                decimalSeparator=","
                allowNegative={false}
                isAllowed={(values) => {
                  return !values.floatValue || values.floatValue <= 100;
                }}
                value={rateio?.percentual}
                onChange={(event) => {
                  formik.setFieldValue(`rateios[${index}].percentual`, event.target.value);
                }}
                error={_errors?.percentual}
                touched={!!_errors?.percentual}
                onBlur={formik.handleBlur}
              />
            </Grid>
            {index >= 0 && (
              <Grid item xs={1}>
                <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <Tooltip title="Excluir" placement="right-end">
                    <IconButton onClick={(e) => handleRemoverRateio(index)}>
                      <MdHighlightOff size={18} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </Grid>
            )}
          </Grid>
        );
      })}
      <Grid item>
        <AddItemButton onClick={handleAdicionarRateio}>Adicionar centro de custo</AddItemButton>
      </Grid>
    </>
  );
};

export default RateioContaReceberForm;
